
import React from 'react';
import './MoonsFlowStep.css';
import checklist from './../../../../assets/img/moonsflow/checklist.svg';
import mouth from './../../../../assets/img/moonsflow/mouth.svg';
import deliverytruck from './../../../../assets/img/moonsflow/deliverytruck.svg';
import dental from './../../../../assets/img/moonsflow/dental.svg';
import website from './../../../../assets/img/moonsflow/website.svg';
import positivevote from './../../../../assets/img/moonsflow/positivevote.svg';
import conveyor from './../../../../assets/img/moonsflow/conveyor.svg';
import heartbox from './../../../../assets/img/moonsflow/heartbox.svg';
import dentistchair from './../../../../assets/img/moonsflow/dentistchair.svg';


class MoonsFlowStep extends React.Component {


    getIcon = (icon) => {
        if(icon === "checklist"){
            return <img src={checklist} className="moonsflowstep icon"/>
        }
        if(icon === "mouth"){
            return <img src={mouth} className="moonsflowstep icon"/>
        }
        if(icon === "deliverytruck"){
            return <img src={deliverytruck} className="moonsflowstep icon"/>
        }
        if(icon === "dental"){
            return <img src={dental} className="moonsflowstep icon"/>
        }
        if(icon === "website"){
            return <img src={website} className="moonsflowstep icon"/>
        }
        if(icon === "positivevote"){
            return <img src={positivevote} className="moonsflowstep icon"/>
        }
        if(icon === "conveyor"){
            return <img src={conveyor} className="moonsflowstep icon"/>
        }
        if(icon === "heartbox"){
            return <img src={heartbox} className="moonsflowstep icon"/>
        }
        if(icon === "dentistchair"){
            return <img src={dentistchair} className="moonsflowstep icon"/>
        }
    }
  render() {
    const {icon, stepNumber, text} = this.props;
    return(
        <div className="moonsflowstep-container">
            <div className="row">
                <div className="col-md-4 text-left">
                    {this.getIcon(icon)}
                </div>
            </div>
            <div className="vertical-separator-10px"></div>
            <div className="row">
                <div className="col-md-12 text-left moonsflowstep step">
                    {stepNumber}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-left moonsflowstep stepdescription">
                    {text}
                </div>
            </div>
        </div>
    );
  }


}

export default MoonsFlowStep;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/MoonsFlowStep/MoonsFlowStep.js